import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { axiosInt, type IModelSummary, API_CORE_URL } from '..';

export const FETCH_CURRENT_MODEL_SUMMARY_KEY = 'fetchCurrentModelSummary';
export const fetchCurrentModelSummaryApi = async (
  modelId: string
): Promise<IModelSummary> => {
  const response = await axiosInt.get<IModelSummary>(
    `${API_CORE_URL}/models/model-id/${modelId}/current/summary`
  );
  return response.data;
};

export const useFetchCurrentModelSummary = (
  modelId: string,
  options?: Partial<
    UseQueryOptions<IModelSummary, Error, IModelSummary, readonly unknown[]>
  >
) => {
  const {
    data: modelSummary,
    isLoading: isLoadingModelSummary,
    error: errorFetchingModelSummary,
  } = useQuery<IModelSummary, Error, IModelSummary, readonly unknown[]>({
    queryKey: [FETCH_CURRENT_MODEL_SUMMARY_KEY, modelId],
    queryFn: () => fetchCurrentModelSummaryApi(modelId),
    ...options,
  });

  return { modelSummary, isLoadingModelSummary, errorFetchingModelSummary };
};
